import React from 'react';

import {Icon, Navbar, NavItem, Row} from "react-materialize";

import * as authHandler from "../../utils/authHandler";
import l10n from "../../l10n/localization";

export default class Header extends React.Component {
    render() {
        return (
            <header className="main-header">
                <Row className="top-bar">
                    <div className="brand-logo">
                        <div className="pull-left">
                            <img src="/images/brand.png" alt="AmSpec Logo" />
                        </div>
                        <div className="pull-right">
                            <h1>{l10n.common.fogTitle}</h1>
                        </div>
                    </div>
                </Row>
                <Navbar right>
                    <NavItem>
                        {authHandler.isAdmin(this.props.user) && <Icon className="pull-left">star&nbsp;</Icon>}
                        {authHandler.isValidUser(this.props.user) && this.props.user.name}
                    </NavItem>
                </Navbar>
            </header>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Header.js